<div
  class="overlay"
  lumAppLoader
  [loading]="loading"
  [classes]="'loading blur'"
></div>
<ng-container *ngIf="sku?.location_stocks?.length; else empty">
  <div class="location-warehouse-app__header p-6">
    <h1 class="mat-h2 font-bold">
      [{{ sku?.internal_sku }}] - {{ sku?.product_name }}
    </h1>
  </div>
  <div class="location-warehouse-selection p-6">
    <div class="flex justify-content-end mb-6">
      <button
        *ngIf="selectedItemKeys.length"
        class="lum-button w-100"
        (click)="openTransferDialog()"
      >
        Initiate Transfer
      </button>
    </div>
    <table
      class="lum-table lum-table--classic striped"
      matSort
      (matSortChange)="onSort($event)"
    >
      <tr>
        <th>
          <mat-checkbox
            (change)="toggleAll($event.checked)"
            [checked]="isAllSelected()"
            [indeterminate]="selectedItemKeys.length > 0 && !isAllSelected()"
          ></mat-checkbox>
        </th>
        <th mat-sort-header="warehouseName">Warehouse</th>
        <th mat-sort-header="location">Location</th>
        <th mat-sort-header="lotNumber">Lot #</th>
        <th mat-sort-header="productionDate">Production Date</th>
        <th mat-sort-header="quantity">Quantity</th>
        <th></th>
      </tr>
      <!-- <ng-container *ngFor="let warehouseStock of sku.location_stocks"> -->
      <tr *ngFor="let data of locationStocks" class="cursor-pointer">
        <td>
          <mat-checkbox
            (change)="toggleSelection(data?.key, $event)"
            [checked]="selectedItemKeys.includes(data?.key)"
          ></mat-checkbox>
        </td>
        <td>{{ data?.warehouseName }}</td>
        <td>{{ data?.location }}</td>

        <td>{{ data?.lotNumber }}</td>
        <td>
          {{ data?.productionDate | date: 'mediumDate' }}
        </td>

        <td>{{ data?.quantity }}</td>
        <th>
          <button
            class="lum-button lum-button--secondary lum-button--small"
            (click)="navigateToEntry(data, $event)"
          >
            Manage Stocks
          </button>
        </th>
      </tr>
      <!-- </ng-container> -->
    </table>
  </div>
</ng-container>
<ng-template #empty>
  <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
</ng-template>
